/* Note: This is an autogenerated file. Please DO NOT modify anything manually here. */
import * as Types from "src/generated/graph-api";

import { gql } from "@apollo/client";
export type GQLAccountSettingsTeamDetailsFieldsFragment = {
	__typename: "IdentityTeam";
	id: string;
	legalName: string | null;
	alias: string | null;
	phoneNumber: string | null;
	email: string | null;
	logoUri: string | null;
	websiteUrl: string | null;
	description: string | null;
	mailingAddress: {
		__typename: "IdentityAddress";
		id: string;
		street1: string | null;
		street2: string | null;
		city: string | null;
		state: string | null;
		postalCode: string | null;
	} | null;
	registeredAddress: {
		__typename: "IdentityAddress";
		id: string;
		street1: string | null;
		street2: string | null;
		city: string | null;
		state: string | null;
		postalCode: string | null;
	} | null;
};

export const AccountSettingsTeamDetailsFieldsFragmentDoc = gql`
    fragment AccountSettingsTeamDetailsFields on IdentityTeam {
  id
  legalName
  alias
  phoneNumber
  email
  logoUri
  websiteUrl
  mailingAddress {
    id
    street1
    street2
    city
    state
    postalCode
  }
  registeredAddress {
    id
    street1
    street2
    city
    state
    postalCode
  }
  description
}
    `;
